"use client";

import React from "react";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const operations = ["Pružanje i održavanje naših usluga", "Personalizacija korisničkog iskustva", "Marketinška komunikacija i obavijesti", "Analitika i poboljšanje funkcionalnosti", "Otkrivanje i sprječavanje prijevara", "Usklađenost s pravnim obvezama", "Tehnička podrška i rješavanje upita"];
export default function WhatWeDo() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253377" id="korištenje-podataka" className="py-20 md:py-28 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-700 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <Badge variant="secondary" className="mb-2 bg-secondary text-secondary-foreground font-default">
              Svrha obrade
            </Badge>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight text-foreground">
              Kako koristimo vaše podatke
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl font-default">
              Vaše podatke prikupljamo i obrađujemo isključivo u svrhe koje su nužne za kvalitetno pružanje naših usluga. Transparentnost nam je prioritet, stoga jasno definiramo svaki aspekt obrade vaših informacija.
            </p>
            <div className="pt-4">
              <Button asChild size="lg" className="group bg-primary text-primary-foreground hover:bg-primary/90 shadow-md rounded-md">
                <Link to="/ContactUsPage">
                  Saznajte više o zaštiti
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={listRef} className={`transition-all duration-700 delay-200 ease-out ${isListVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <Card className="border-border shadow-xl bg-card/50 backdrop-blur-sm rounded-lg">
              <CardContent className="p-6 md:p-8">
                <ul className="space-y-5">
                  {operations.map((operation, index) => <li key={index} data-index={index} className="flex items-start gap-4 group">
                      <div className="mt-0.5 bg-primary/10 p-2 rounded-md shrink-0 transition-colors group-hover:bg-primary/20">
                        <ShieldCheck className="w-5 h-5 text-primary" />
                      </div>
                      <span className="text-base md:text-lg font-medium text-card-foreground leading-snug pt-1.5 font-default">
                        {operation}
                      </span>
                    </li>)}
                </ul>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}